import { createContext } from 'react'

const AppContext = createContext({
    state: {
        dialog: null,
        user: {
            id: 0,
            name: '',
            image: '',
            lastVenue: 1,
            token: '',
            permissions: { backoffice: false }
        },
        token: '',
    },
    actions: {
        setDialog: () => {},
        updateToken: () => {}, 
        updateUser: () => {},
    }
})

export default AppContext